import {
  Alert,
} from 'react-bootstrap'
import BookingsListing from '../BookingsListing'
import {
  useParams,
} from 'react-router-dom'

const BookingsListingContainer = () => {
  const { bookingId } = useParams()
  return (
    <BookingsListing
      isAdmin
      bookingId={bookingId}
      noBookings={() => (
        <Alert variant="warning">
          No bookings found.
        </Alert>
        )
      }
    />
  )
}

export default BookingsListingContainer
